import React from "react"
import SideBar from "../../../common/layout/sidebar.component.jsx"
import EcommerceConfigurationContainerWrapper from "../sections/EcommerceConfigurationContainerWrapper"

const EcommerceConfigurationPage = () => {

    SideBar.activateMenu("ecommerce-configuration")
    return (
        <EcommerceConfigurationContainerWrapper/>
    )
}

export default EcommerceConfigurationPage





// WEBPACK FOOTER //
// ./src/settings/ecommerce/pages/EcommerceConfigurationPage.tsx